import React, { useState, useEffect } from 'react'
import Spinner from '../../common/Spinner'

import { Box, Text, Grid } from "grommet"
import { FormUp, FormDown, StatusGood, StatusCritical, StatusWarning } from 'grommet-icons'

import TTJsonTree from '../../common/TTJsonTree'
import TTCopyClipboard from '../../common/TTCopyClipboard'

import { gql, useQuery } from '@apollo/client';

import { useConnection } from '../../../utils/connection'
import * as beautify from "json-beautify"
import * as moment from "moment-timezone"
import TimeAgo from 'react-timeago'
import { THREE_MINUTES } from '../../../utils/pollIntervals'
import { deepClone } from '../../../utils/clone'


const APP_DIAGNOSTICS_QUERY = gql`
query($envName: String!, $clusterName: String!, $type: [String!]!) {
    diagnostics(
        where: {
            env: {_eq: $envName }, 
            name: {_eq: $clusterName }, 
            type: {_in: $type}
        }) {
      output
      timestamp
      type
      id
    }
  }
`


export const BouncerDiagnosticsView = ({ token, envName, clusterName }) => {

    const result = useQuery(
        APP_DIAGNOSTICS_QUERY,
        { variables: { clusterName: clusterName, envName: envName, type: "bouncer" }, pollInterval: THREE_MINUTES }
    )

    const [basicStatsSelected, setBasicStatsSelected] = useState(false)

    const handleClickBasic = () => {
        setBasicStatsSelected(!basicStatsSelected)
    }

    const [diagnosticsAlert, setdiagnosticsAlert] = useState(false)
    const [diagnosticsTimestamp, setdiagnosticsTimestamp] = useState('')
    const [diagnosticsOutput, setdiagnosticsOutput] = useState({})

    useEffect(() => {
        if (!result.loading && result.data && result.data.diagnostics && result.data.diagnostics.length > 0) {
            let bouncerDiagnostics = deepClone(result.data.diagnostics[0])
            let diagnosticsTimestampTemp = bouncerDiagnostics.timestamp
            diagnosticsTimestampTemp = moment(moment(diagnosticsTimestampTemp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
            diagnosticsTimestampTemp = moment(diagnosticsTimestampTemp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')

            setdiagnosticsTimestamp(diagnosticsTimestampTemp)
            setdiagnosticsAlert(bouncerDiagnostics.output.alert || false)
            setdiagnosticsOutput(bouncerDiagnostics.output)

        }
    }, [result.loading, result.data, token.timezone])


    if (result && (result.loading)) {
        return (
            <Spinner />
        )
    }

    // This diagnostic check is only for ext-prod-live, ext-prod-sim
    if (envName !== "ext-prod-live" && envName !== "ext-prod-sim" && envName !== "ext-uat-cert") {
        return null
    }


    return (
        <>
            <Box direction="row" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal" align="start" alignContent="start" alignSelf="start">
                <Text color="dark-3" size="small" margin="none" weight="bold">Diagnostics check</Text>
                <TTCopyClipboard copyText={beautify(diagnosticsOutput, null, 2, 80)} />
            </Box>

            <Grid
                rows={['100%', '100%']}
                columns={['50%', '45%']}
                gap="0px"
                flex
                areas={[
                    { name: 'left', start: [0, 0], end: [0, 0] },
                    { name: 'right', start: [1, 0], end: [1, 0] },
                ]}
            >

                <Box gridArea="right">
                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">{clusterName}</Text>
                        </Text>
                    </Box>

                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px", top: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">Ran : <TimeAgo date={diagnosticsTimestamp} /></Text>
                        </Text>
                    </Box>

                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">{diagnosticsTimestamp}</Text>
                        </Text>
                    </Box>
                </Box>

                {!diagnosticsAlert &&
                    <Box background="light-1"
                        elevation="xsmall"
                        margin="xsmall"
                        gridArea="left"
                        alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall"
                        align="start" gap="small" border={{ size: "small", side: "all", color: "ttok" }}>
                        <StatusGood size="medium" color="ttok" />
                        <Box gap="xsmall">
                            <Text size="13px" color="ttok" weight="bold">Healthy</Text>
                        </Box>
                    </Box>
                }
                <Box
                    gridArea="left"
                    alignSelf="start" alignContent="start" pad="small" direction="column" round="xsmall"
                    align="start" gap="xsmall">

                    {diagnosticsAlert && diagnosticsOutput.alert_reasons.sort().map(msg => {
                        const colour = (msg === "Accounts are not balanced.") ? "ttwarning" : "ttdown"
                        return (
                            <Box elevation="xsmall" background="light-1" direction="row" pad="xsmall" key={msg} border={{ size: "small", side: "all", color: colour }} round="xsmall">
                                {msg === "Accounts are not balanced." ? <StatusWarning size="medium" color="ttwarning" /> : <StatusCritical size="medium" color="ttdown" />}
                                <Box direction="row" gap="xsmall">
                                    <Text size="13px" color={colour} weight="bold">{msg}</Text>
                                </Box>
                            </Box>)
                    })
                    }

                </Box>

            </Grid>

            <Box direction="row" gap="xsmall" align="center" pad="small" onClick={handleClickBasic}>
                <Text size="xsmall" color="dark-3" weight="bold" margin={{ top: "xsmall", bottom: "xsmall" }}>Details</Text>
                {(!basicStatsSelected) ? <FormDown color="brand" /> : <FormUp color="brand" />}
            </Box>

            {basicStatsSelected &&
                <TTJsonTree data={diagnosticsOutput} expandAll={true} />
            }
        </>
    )
}

export const OCDiagnosticsView = ({ token, envName, clusterName, ocSchedule, ocInstanceId, sessionData }) => {

    if (ocInstanceId) {
        ocInstanceId = ocInstanceId.split("(")[0].replace(/ +/g, "")
    } else {
        ocInstanceId = ''
    }

    const result = useQuery(
        APP_DIAGNOSTICS_QUERY,
        { variables: { clusterName: clusterName, envName: envName, type: ['oc', 'oc-aotc'] }, pollInterval: THREE_MINUTES }
    )

    const [basicStatsSelected, setBasicStatsSelected] = useState(false)

    const handleClickBasic = () => {
        setBasicStatsSelected(!basicStatsSelected)
    }

    const [diagnosticDetails, setDiagnosticDetails] = useState(false)

    const connectionLookup = useConnection(envName)

    const [diagnosticsTimestamp, setdiagnosticsTimestamp] = useState('')
    const [diagnostic_items, setdiagnostic_items] = useState([])
    const [diagnosticOutputRaw, setdiagnosticOutputRaw] = useState('')

    useEffect(() => {

        const MAPPING = {
            "oc": {
                "healthyMessage": "Connections in Zookeeper",
                "unhealthyMessage": "Missing connections"
            },
            "oc-aotc": {
                "healthyMessage": "AOTC/Fastcross",
                "unhealthyMessage": "AOTC/Fastcross Failure"
            }
        }

        let diagnostic_itemsTemp = []
        let diagnosticOutputRawTemp = []

        if (!result.loading && result.data && result.data.diagnostics && result.data.diagnostics.length > 0) {
            result.data.diagnostics.forEach(ocDiagnostics => {

                if (!(ocDiagnostics.type in MAPPING)) {
                    return
                }

                let diagnosticsTimestampTemp = ocDiagnostics.timestamp
                diagnosticsTimestampTemp = moment(moment(diagnosticsTimestampTemp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                diagnosticsTimestampTemp = moment(diagnosticsTimestampTemp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
                setdiagnosticsTimestamp(diagnosticsTimestampTemp)

                let diagnosticsOutput = ocDiagnostics.output
                let diagnosticsAlert = Object.keys(diagnosticsOutput).length > 0
                diagnosticOutputRawTemp.push(diagnosticsOutput)

                if (ocSchedule && ocSchedule.status && !ocSchedule.status.includes("UP")) {
                    diagnosticsAlert = false
                }

                if (diagnosticsAlert) {
                    diagnostic_itemsTemp.push({
                        "id": ocDiagnostics.id,
                        "output": JSON.stringify(diagnosticsOutput),
                        "alert": diagnosticsAlert,
                        "return_element": <Box background="light-1"
                            elevation="xsmall"
                            margin="xsmall"
                            width="90%"
                            alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall"
                            align="start" gap="small" border={{ size: "small", side: "all", color: "ttdown" }}>
                            <StatusCritical size="medium" color="ttdown" />
                            <Box gap="xsmall">
                                <Text size="12px" color="ttdown"
                                    weight="bold">{MAPPING[ocDiagnostics.type]["unhealthyMessage"]}</Text>
                            </Box>
                        </Box>
                    })
                } else {
                    diagnostic_itemsTemp.push({
                        "id": ocDiagnostics.id,
                        "output": JSON.stringify(diagnosticsOutput),
                        "alert": diagnosticsAlert,
                        "return_element": <Box background="light-1"
                            elevation="xsmall"
                            margin="xsmall"
                            width="90%"
                            alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall"
                            align="start" gap="small" border={{ size: "small", side: "all", color: "ttok" }}>
                            <StatusGood size="medium" color="ttok" />
                            <Box gap="xsmall">
                                <Text size="12px" color="ttok" weight="bold">{MAPPING[ocDiagnostics.type]["healthyMessage"]}</Text>
                            </Box>
                        </Box>
                    })
                }

                setdiagnostic_items(diagnostic_itemsTemp)
                setdiagnosticOutputRaw(diagnosticOutputRawTemp)

            })

        }
    }, [result.loading, result.data, token.timezone, ocSchedule])

    // Show dedicated connections that are not on the right OC
    const [dedicatedDiagnostics, setdedicatedDiagnostics] = useState([])

    useEffect(() => {
        if (connectionLookup && sessionData) {

            let dedicatedDiagnosticsTemp = []

            sessionData.forEach(conn => {
                let connShouldBeDedicated = conn.dedicated_instance || ""
                let connName = connectionLookup[conn.id] ? connectionLookup[conn.id].name : 'SIM'
                if ((connShouldBeDedicated.length > 0 || ocInstanceId.length > 0) && connShouldBeDedicated !== ocInstanceId && !connName.includes("SIM")) {
                    dedicatedDiagnosticsTemp.push(conn.id + ' -> ' + connShouldBeDedicated)
                }
            })
            setdedicatedDiagnostics(dedicatedDiagnosticsTemp)
        }
    }, [sessionData, connectionLookup, ocInstanceId])

    if (result && (result.loading)) {
        return (
            <Spinner />
        )
    }

    // This diagnostic check is only for ext-OC environments
    if (envName !== "ext-prod-live" && envName !== "ext-uat-cert" && envName !== "ext-alt-live") {
        return null
    }

    return (
        <>
            <Box direction="row" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal" align="start" alignContent="start" alignSelf="start">
                <Text color="dark-3" size="small" margin="none" weight="bold">Diagnostics check</Text>
                <TTCopyClipboard copyText={beautify(diagnosticOutputRaw, null, 2, 80)} />
            </Box>

            <Grid
                rows={['100%', '100%']}
                columns={['50%', '50%']}
                gap="0px"
                areas={[
                    { name: 'left', start: [0, 0], end: [0, 0] },
                    { name: 'right', start: [1, 0], end: [1, 0] },
                ]}
            >

                <Box gridArea="right">
                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">{clusterName}</Text>
                        </Text>
                    </Box>

                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px", top: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">Ran : <TimeAgo date={diagnosticsTimestamp} /></Text>
                        </Text>
                    </Box>

                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">{diagnosticsTimestamp}</Text>
                        </Text>
                    </Box>
                </Box>

                <Box gridArea="left" gap="none">
                    {diagnostic_items.map(item => (
                        <div key={item.id}>
                            {item.return_element}
                            {item.alert &&
                                <Box direction="row" gap="xsmall" align="center" pad="small" onClick={() => setDiagnosticDetails(!diagnosticDetails)}>
                                    <Text size="xsmall" color="dark-3" weight="bold" margin={{ top: "xsmall", bottom: "xsmall" }}>Details</Text>
                                    {(!diagnosticDetails) ? <FormDown color="brand" /> : <FormUp color="brand" />}
                                </Box>}
                            {item.alert && diagnosticDetails &&
                                <TTJsonTree data={JSON.parse(item.output)} expandAll={true} />
                            }
                        </div>
                    ))}

                    {dedicatedDiagnostics.length > 0 &&
                        <Box background="light-1"
                            elevation="xsmall"
                            margin="xsmall"
                            width="90%"
                            alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall"
                            align="start" gap="small" border={{ size: "small", side: "all", color: "ttwarning" }}>
                            <StatusWarning size="medium" color="ttwarning" />
                            <Box gap="xsmall">
                                <Text size="12px" color="ttwarning" weight="bold">{"Dedicated: " + dedicatedDiagnostics.join(", ")}</Text>
                            </Box>
                        </Box>
                    }

                </Box>

            </Grid>

            <Box direction="row" gap="xsmall" align="center" pad="small" onClick={handleClickBasic}>
                <Text size="xsmall" color="dark-3" weight="bold" margin={{ top: "xsmall", bottom: "xsmall" }}>Exchange Schedule</Text>
                {(!basicStatsSelected) ? <FormDown color="brand" /> : <FormUp color="brand" />}
            </Box>

            {basicStatsSelected &&
                <TTJsonTree data={ocSchedule} expandAll={true} />
            }
        </>
    )
}

export const JunoUpDiagnosticsView = ({ token, envName, datacenterName }) => {

    const result = useQuery(
        APP_DIAGNOSTICS_QUERY,
        { variables: { clusterName: datacenterName, envName: envName, type: "juno_up" }, pollInterval: THREE_MINUTES }
    )

    const [basicStatsSelected, setBasicStatsSelected] = useState(false)

    const handleClickBasic = () => {
        setBasicStatsSelected(!basicStatsSelected)
    }

    const [diagnosticsAlert, setdiagnosticsAlert] = useState(false)
    const [diagnosticsTimestamp, setdiagnosticsTimestamp] = useState('')
    const [diagnosticsOutput, setdiagnosticsOutput] = useState({})

    useEffect(() => {
        if (!result.loading && result.data && result.data.diagnostics && result.data.diagnostics.length > 0) {
            let junoUpDiagnostics = deepClone(result.data.diagnostics[0])
            let diagnosticsTimestampTemp = junoUpDiagnostics.timestamp
            diagnosticsTimestampTemp = moment(moment(diagnosticsTimestampTemp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
            diagnosticsTimestampTemp = moment(diagnosticsTimestampTemp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')

            setdiagnosticsTimestamp(diagnosticsTimestampTemp)
            setdiagnosticsAlert(junoUpDiagnostics.output.alert || false)
            setdiagnosticsOutput(junoUpDiagnostics.output)

        }
    }, [result.loading, result.data, token.timezone])


    if (result && (result.loading)) {
        return (
            <Spinner />
        )
    }

    // This diagnostic check is only for ext-prod-live, ext-prod-sim
    if (envName !== "ext-prod-live" && envName !== "ext-prod-sim") {
        return null
    }


    return (
        <>
            <Box direction="row" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal" align="start" alignContent="start" alignSelf="start">
                <Text color="dark-3" size="small" margin="none" weight="bold">Diagnostics check</Text>
                <TTCopyClipboard copyText={beautify(diagnosticsOutput, null, 2, 80)} />
            </Box>

            <Grid
                rows={['100%', '100%']}
                columns={['50%', '45%']}
                gap="0px"
                flex
                areas={[
                    { name: 'left', start: [0, 0], end: [0, 0] },
                    { name: 'right', start: [1, 0], end: [1, 0] },
                ]}
            >

                <Box gridArea="right">
                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">Data Center: {datacenterName}</Text>
                        </Text>
                    </Box>

                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px", top: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">Ran: <TimeAgo date={diagnosticsTimestamp} /></Text>
                        </Text>
                    </Box>

                    <Box flex={false} pad="3px" direction="row" margin={{ left: "5px" }} background="light-1" align="start" alignSelf="start" alignContent="start" round="xsmall">
                        <Text color="dark-3" size="xsmall" margin="none" textAlign="start">
                            <Text color="dark-3" size="xsmall" margin="none" textAlign="start" weight="bold">{diagnosticsTimestamp}</Text>
                        </Text>
                    </Box>
                </Box>

                {!diagnosticsAlert &&
                    <Box background="light-1"
                        elevation="xsmall"
                        margin="xsmall"
                        gridArea="left"
                        alignSelf="start" alignContent="start" pad="small" direction="row" round="xsmall"
                        align="start" gap="small" border={{ size: "small", side: "all", color: "ttok" }}>
                        <StatusGood size="medium" color="ttok" />
                        <Box gap="xsmall">
                            <Text size="13px" color="ttok" weight="bold">Healthy</Text>
                        </Box>
                    </Box>
                }
                <Box
                    gridArea="left"
                    alignSelf="start" alignContent="start" pad="small" direction="column" round="xsmall"
                    align="start" gap="xsmall">

                    {diagnosticsAlert && diagnosticsOutput.alert_reasons.sort().map(msg => {
                        return (
                            <Box elevation="xsmall" background="light-1" direction="row" pad="xsmall" key={msg} border={{ size: "small", side: "all", color: "ttwarning" }} round="xsmall">
                                <StatusWarning size="medium" color="ttwarning" />
                                <Box direction="row" gap="xsmall">
                                    <Text size="13px" color="ttwarning" weight="bold">{msg}</Text>
                                </Box>
                            </Box>)
                    })
                    }

                </Box>

            </Grid>

            <Box direction="row" gap="xsmall" align="center" pad="small" onClick={handleClickBasic}>
                <Text size="xsmall" color="dark-3" weight="bold" margin={{ top: "xsmall", bottom: "xsmall" }}>Details</Text>
                {(!basicStatsSelected) ? <FormDown color="brand" /> : <FormUp color="brand" />}
            </Box>

            {basicStatsSelected &&
                <TTJsonTree data={diagnosticsOutput} expandAll={true} />
            }
        </>
    )
}


const HealthStatusServiceDiagnostics = ({ token, envSelected, ocSchedule, result, serviceGroupName }) => {
    return (
        <>
            {serviceGroupName === 'Bouncer' && result.data.service_node && result.data.service_node.length > 0 &&
                result.data.service_node[0].zookeeper && result.data.service_node[0].zookeeper.custom_data &&
                result.data.service_node[0].zookeeper.custom_data.clusterName &&
                <BouncerDiagnosticsView token={token} envName={envSelected} clusterName={result.data.service_node[0].zookeeper.custom_data.clusterName} />
            }

            {/* {(serviceGroupName === 'OC' || serviceGroupName === 'FIX Order Gateway') && result.data.service_node && result.data.service_node.length > 0 &&
                result.data.service_node[0].zookeeper && result.data.service_node[0].zookeeper.custom_data &&
                result.data.service_node[0].zookeeper.custom_data.cluster &&
                result.data.service_node[0].zookeeper.custom_data.cluster.name &&
                <OCDiagnosticsView
                    token={token} envName={envSelected} ocSchedule={ocSchedule}
                    clusterName={result.data.service_node[0].zookeeper.custom_data.cluster.name}
                    sessionData={result.data.service_node[0].sessionData}
                    ocInstanceId={result.data.service_node[0].zookeeper.custom_data.dedicated_instance_id}
                />
            } */}

            {serviceGroupName === 'JunoUp' && result.data.service_node && result.data.service_node.length > 0 &&
                result.data.service_node[0].zookeeper && result.data.service_node[0].zookeeper.datacenter &&
                <JunoUpDiagnosticsView
                    token={token}
                    envName={envSelected}
                    datacenterName={result.data.service_node[0].zookeeper.datacenter}
                />
            }

        </>
    )
}

export default HealthStatusServiceDiagnostics
